import React from 'react'
import { createRoot } from 'react-dom/client'
import ProductTile from "./ProductTile.jsx"
import { makeRequest } from "../../utils/Storefront.js"
import { makeid } from '../../utils/helpers'

const appAttribute = 'product-tile'
const apiAttribute = 'data-plp-item'

// document.addEventListener('DOMContentLoaded', () => {
//   const productTiles = document.querySelectorAll(`[${appAttribute}]:not([initial-load="false"])`)
//   productTiles.forEach((tile) => setupProductTile(tile))
//   setupApiTiles()
// })

const setupApiTiles = (parent=document, callback=null) => {
  return;
  const apiTiles = parent.querySelectorAll(`[${apiAttribute}][data-inited="false"]`)
  apiTiles.forEach(tile => tile.setAttribute('data-inited', 'true'))
  const ids = Array.from(apiTiles).map(tile => `"gid://shopify/Product/${tile.dataset.plpItem}"`)
  if(ids.length > 0) {
    const query = `query @inContext(country: ${Shopify.country}, language: ${Shopify.locale.toUpperCase()}) {
      nodes(ids: [${ids.join(',')}]) {
        ...on Product {
          ${window.productResponse}
        }
      }
    }`
    makeRequest(
      (results) => {
        results.data?.nodes?.forEach(json => {
          const id = json?.id?.replace('gid://shopify/Product/', '')
          if(id) {
            const wrappers = parent.querySelectorAll(`[${apiAttribute}="${id}"]`)
            wrappers.forEach(wrapper => {
              const randKey = makeid(5)
              const dataId = `plp-tile-${id}-${randKey}`
              const tile = document.createElement('div')
              tile.setAttribute('data-id', dataId)
              tile.setAttribute(appAttribute, false)
              tile.setAttribute('json', JSON.stringify(json))
              tile.setAttribute('lazyload', wrapper.getAttribute('lazyload'))
              tile.setAttribute('index', wrapper.getAttribute('index'))
              tile.setAttribute('look', wrapper.getAttribute('look'))
              tile.setAttribute('plp_index', wrapper.getAttribute('data-plp-index'))
              const div = document.createElement('div')
              div.appendChild(tile)
              wrapper.innerHTML = div.innerHTML
              setTimeout(() => {
                setupProductTile(wrapper.querySelector(`[data-id="${dataId}"]`))
              }, 100)
            })
          }
        })
        const swatInterval = setInterval(() => {
          if (typeof window._swat != 'undefined' && window._swat && window._swat.initializeActionButtons) {
            clearInterval(swatInterval)
            setTimeout(() => {
              window._swat.initializeActionButtons('#MainContent', '.plp-wishlist-btn')
            }, 500)
          }
        }, 300)
        if(callback) callback()
      },
      query
    )
  }
}
window.setupApiTiles = setupApiTiles

const setupProductTile = (productTileEl) => {
  if(typeof productTileEl != 'undefined') {
    const jsonRaw = productTileEl.getAttribute('json')
    const json = JSON.parse(jsonRaw)
    const lazyloadRaw = productTileEl.getAttribute('lazyload')
    const lazyload = (typeof lazyloadRaw == 'undefined' ? true : lazyloadRaw)
    const lookRaw = productTileEl.getAttribute('look')
    const look = (typeof lookRaw == 'undefined' ? false : lookRaw)
    const indexRaw = productTileEl.getAttribute('index')
    const plpIndexRaw = productTileEl.getAttribute('plp_index')
    const plpIndex = plpIndexRaw ? parseInt(plpIndexRaw) : null
    const root = createRoot(productTileEl)
    root.render(
      <ProductTile json={json}
        lazyload={lazyload}
        forloopIndex={indexRaw}
        plpIndex={plpIndex}
        look={look}
      />
    )
  }
}

window.setupATile = setupProductTile

window.setupProductTiles = (tiles) => {
  return;
  tiles.forEach((tile) => setupProductTile(tile))
}